// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Button, Modal } from '@mui/material';
import { CloseButton } from '@shared/ui-kit/components';
import { Equity } from '@advisor-app/features/screener';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ButtonCustomizeModal: FC = () => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  return (
    <>
      <Button
        variant="tonal"
        color="secondary"
        className="float-right"
        onClick={handleOpen}
      >
        {t('ai-builder.customize-universe', { ns: 'ai-builder' }) as string}
      </Button>

      <Modal open={openModal} sx={{ overflowY: 'scroll' }}>
        <div className="customize-modal-container absolute inset-x-[7.5%] top-4 w-[85%] rounded-xl px-9 py-4">
          <CloseButton onClick={handleClose} />
          <Equity
            name={
              t('ai-builder.customize-universe', { ns: 'ai-builder' }) as string
            }
            id="ai-builder"
          />
        </div>
      </Modal>
    </>
  );
};
